module.exports = __webpack_public_path__ + "static-intranet/media/logo.9cd1dd24.svg";